var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-1"},[_c('v-col',{staticClass:"py-0"},[_c('v-text-field',_vm._b({attrs:{"value":_vm.pValue,"label":_vm.lgLabel,"counter":"1024","maxLength":"1024","dense":"","outlined":""},on:{"input":v => _vm.handleUpdate({ value: v })}},'v-text-field',{ ..._vm.$attrs },false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }